<template>
  <svg
    viewBox="0 0 24 24"
    width="1.5em"
    height="1.5em"
    fill="currentColor"
    class="zds-icon bw_sBR X9n9TI DlJ4rT _5Yd-hZ HlZ_Tf I_qHp3"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M2.231 8.25h2.282a.75.75 0 0 0 0-1.5H2.231a.75.75 0 0 0 0 1.5m2.266 3a.75.75 0 0 0 0-1.5H.753a.75.75 0 0 0 0 1.5zm.017 3.001a.75.75 0 0 0 0-1.5H2.21a.75.75 0 0 0 0 1.5z"
    ></path>
    <path
      d="m23.81 11.501-3.368-3.738a.75.75 0 0 0-.557-.248h-3.378V4.497a.75.75 0 0 0-.75-.75H3.711a.75.75 0 0 0 0 1.5l11.298-.004.003 10.513-4.953.004c-.519-.897-1.478-1.508-2.588-1.508s-2.07.61-2.588 1.508H3.712a.75.75 0 1 0 0 1.5h.76a2.999 2.999 0 0 0 5.998 0h5.276l.76.003a2.999 2.999 0 0 0 5.997 0h.749a.75.75 0 0 0 .75-.75v-4.51a.75.75 0 0 0-.193-.502m-16.338 7.25a1.5 1.5 0 1 1 0-2.999 1.5 1.5 0 0 1 0 2.999m12.032 0a1.5 1.5 0 1 1 0-2.999 1.5 1.5 0 0 1 0 2.999m2.998-2.988h-.408a2.99 2.99 0 0 0-2.59-1.511 2.99 2.99 0 0 0-2.59 1.511h-.402l-.003-6.748h3.042l2.95 3.278z"
    ></path>
  </svg>
</template>

<script setup lang="ts"></script>
